import {
  cn
} from "./chunk-DYSUVPH5.mjs";
import {
  __objRest,
  __spreadValues
} from "./chunk-32ZPS4GN.mjs";

// src/divider/Divider.tsx
import { Slot } from "@radix-ui/react-slot";
import React from "react";
var Divider = (_a) => {
  var _b = _a, {
    className,
    asChild = false
  } = _b, props = __objRest(_b, [
    "className",
    "asChild"
  ]);
  const Comp = asChild ? Slot : "div";
  return /* @__PURE__ */ React.createElement(Comp, __spreadValues({ className: cn("mx-4 block border-b", className) }, props));
};

export {
  Divider
};
